import React, { useEffect, useState } from 'react';
import { gql } from "@apollo/client";
import { useMutation } from '@apollo/react-hooks';
import './Login.scss'
import Cookies from 'js-cookie'
import { Icon as LegacyIcon, Form } from '@ant-design/compatible';
import { Input, Button, Checkbox } from 'antd';
import { Col, Row, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { LockOutlined, EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import { useAppContext } from "../../useAppState";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

const LOGIN_STUDENT = gql`
  mutation LoginStudent($email: String!, $password: String!) {
    loginStudent(email: $email, password: $password)
  }
`;

const Login = (props) => {

    const { t } = useTranslation();
    const { state, actions } = useAppContext();

    const [errorSubmit, setErrorSubmit] = useState('');
    const [bRollImage, setBRollImage] = useState(null);
    const [connectByLoginPassword, setConnectByLoginPassword] = useState(false);
    const [loginAttempt, setLoginAttempt] = useState(false);
    const [meStudentLoginError, setMeStudentLoginError] = useState(null);
    let ispCookie = Cookies.get('isp');
    let ipUsed = Cookies.get('ipUsed');
    const PRODUCTION_SSO_URL = 'https://icite.intactfc.com/intact/login';

    // Check cookies for loginAdmin or loginOutilsWeb
    if (Cookies.get('loginAdmin') || Cookies.get('loginOutilsWeb')) {
        window.location.href = PRODUCTION_SSO_URL;
    }

    const isInternalNetwork = (
        ['Intact Financial Corporation', 'Partner Solutions Inc'].includes(ispCookie) ||
        (ispCookie && ispCookie.includes('Intact')) ||
        (ipUsed && (
            ipUsed.includes('142.216.101') ||
            ipUsed.includes('142.216.137') ||
            ipUsed.includes('142.216.168') ||
            ipUsed.includes('216.23.137.246') ||
            ipUsed.includes('216.23.137.247') ||
            ipUsed.includes('216.23.137')
        ))
    )


    const [login] = useMutation(
        LOGIN_STUDENT,
        {
            onCompleted(response) {

                console.log(response.loginStudent);
                if (response.loginStudent && response.loginStudent !== null && response.loginStudent !== 'null') {
                    Cookies.set('token', response.loginStudent, { expires: 90 });
                    setErrorSubmit('');
                    if (Cookies.get('directLinkPath') && Cookies.get('directLinkPath') !== null && Cookies.get('directLinkPath') !== 'null') {

                        if (Cookies.get('directLinkPath') === '/accueil') {
                            props.history.push('/liste-formations');
                        } else {
                            props.history.push(Cookies.get('directLinkPath'))
                        }

                    } else {
                        props.history.push('/liste-formations')
                    }
                } else {
                    setErrorSubmit('Une Erreur s\'est produite');
                    Cookies.remove('token');
                }
                setLoginAttempt(false)
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
                if (graphQLErrors[0].message) {
                    setErrorSubmit(graphQLErrors[0].message)
                } else {
                    setErrorSubmit('Une Erreur s\'est produite');
                }
                Cookies.remove('token');
                setLoginAttempt(false)
            }
        }
    );

    const getObject = JSON.parse(localStorage.getItem('loginSave'));

    useEffect(() => {
        ReactGA.send('pageview', { path: window.location.pathname + window.location.search });

        props.form.setFieldsValue({
            email: getObject ? getObject.email : null,
            password: getObject ? getObject.password : null,
            remember: getObject ? getObject.remember : null
        });
        console.log(Cookies.get('token'));
        if ((Cookies.get('token') && Cookies.get('token') !== null && Cookies.get('token') !== 'null')) {
            props.history.push('/liste-formations')
        }

        if (Cookies.get('meStudentLoginError')) {
            setMeStudentLoginError(Cookies.get('meStudentLoginError'))
            Cookies.remove('meStudentLoginError')
        }

        let bRollImagesArr = [
            state.imagesSourcesFilesUrl + "b-roll-image-01.jpg",
            state.imagesSourcesFilesUrl + "b-roll-image-02.jpg",
            state.imagesSourcesFilesUrl + "b-roll-image-03.jpg",
            state.imagesSourcesFilesUrl + "b-roll-image-04.jpg",
        ];
        setBRollImage(bRollImagesArr[Math.floor(Math.random() * bRollImagesArr.length)])

    }, []);

    const changeLangHandler = (e) => {
        e.preventDefault();
        if (state.lang === "fr") {
            actions.changeLang('en')
        } else {
            actions.changeLang('fr')
        }
    };

    const handleSubmit = e => {
        e.preventDefault();
        getValsAndConnect();
        setLoginAttempt(true)
    };

    const getValsAndConnect = () => {
        props.form.validateFields((err, values) => {
            if (!err) {
                login({
                    variables: {
                        email: values.email,
                        password: values.password
                    }
                });
                if (values.remember) {
                    localStorage.setItem('loginSave', JSON.stringify(values));
                } else {
                    localStorage.removeItem('loginSave');
                }
            }
        });
    };

    const { getFieldDecorator } = props.form;

    return (
        <div className="login">
            <Row className={'pageRow'}>
                <Col md="5" className='login-image-side d-none d-md-block'>
                    <div className={'image-background'} style={{ backgroundImage: `url(${bRollImage})` }}></div>
                </Col>

                <Col xs="12" md="7" className={'login-form-side'}>
                    {
                        connectByLoginPassword ?
                            (
                                <div className={'return-btn'} onClick={() => setConnectByLoginPassword(false)}>
                                    <FontAwesomeIcon className={'left-arrow'} icon={faAngleLeft} />
                                    <p>{t('login-page-return-btn')}</p>
                                </div>
                            ) : null
                    }

                    <div className={"lang-btn-login"}>
                        <a href="#" className="lang-selector" onClick={changeLangHandler}>{t('dashboardContainerFr/Eng')}</a>
                    </div>

                    <div className={'form-container'}>
                        <img src={state.imagesSourcesFilesUrl + "icite-logo.png"} alt="logo" className={'logo'} />
                        <h1 className='d-none' aria-label='Icité'>Icité</h1>
                        <h2>{t('login-page-welcome')}</h2>
                        <p className={'summary-msg'}>
                            {connectByLoginPassword ? t('login-page-login-to-start') : t('login-page-chose-login-type')}
                        </p>
                        {
                            !connectByLoginPassword ?
                                (
                                    <div className={'login-options'}>
                                        {/* <a href={process.env.REACT_APP_ENV === 'production' ? "https://icite.intactfc.com/intact/login-employee" : "https://icite.intactfc.com/dev/intact/login-employee"}>
                                            <Button type="danger" htmlType="submit" className="login-intact-btn">
                                                {t('login-page-login-type-intact')}
                                            </Button>
                                        </a> */}



                                        {
                                            process.env.REACT_APP_ENV === 'production' ?
                                                (
                                                    <a href={"https://icite.intactfc.com/intact/login-external"}>
                                                        <Button type="primary" htmlType="submit" className="login-not-intact-btn">
                                                            {t('login-page-login-type-externe-portal')}
                                                        </Button>
                                                    </a>
                                                ) : null
                                        }
                                        <hr />

                                        <Button style={{ marginTop: 15 }} type="primary" htmlType="submit" className="login-not-intact-btn" onClick={() => { setConnectByLoginPassword(true); actions.setMeStudentLoginError(null) }}>
                                            {t('login-page-login-type-externe')}
                                        </Button>



                                        {
                                            state.meStudentLoginError ?
                                                (
                                                    <Alert className={'error-submit'} style={{ marginTop: 15, whiteSpace: 'pre-line' }} variant={'danger'}>
                                                        {state.meStudentLoginError}
                                                    </Alert>
                                                ) : null
                                        }
                                    </div>
                                )
                                :
                                (
                                    <Form onSubmit={handleSubmit} className="login-form">
                                        <Form.Item label={t('login-page-form-email-label')} hasFeedback className={'form-input'}>
                                            {getFieldDecorator('email', {
                                                rules: [
                                                    {
                                                        type: 'email',
                                                        message: t('login-page-form-email-invalid-message'),
                                                    },
                                                    {
                                                        required: true,
                                                        message: t('login-page-form-email-req-message'),
                                                    },
                                                ],
                                            })(<Input placeholder={t('login-page-form-email-label')} />)}
                                        </Form.Item>

                                        <Form.Item label={t('login-page-form-password-label')} hasFeedback className={'form-input'}>
                                            {getFieldDecorator('password', {
                                                rules: [{ required: true, message: t('login-page-form-password-req-message') }],
                                            })(

                                                <Input.Password
                                                    prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                    placeholder={t('login-page-form-password-label')}
                                                    type="password"
                                                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                                />


                                            )}
                                        </Form.Item>

                                        <Form.Item className={'form-submit'}>
                                            {getFieldDecorator('remember', {
                                                valuePropName: 'checked',
                                                initialValue: true,
                                            })(<Checkbox>{t('login-page-form-remember-me')}</Checkbox>)}
                                            <Link className="login-form-forgot" to="/mot-de-passe-oublie">{t('forgot-password-page-title')}</Link>
                                            <Button type="primary" htmlType="submit" className="login-form-button">
                                                {t('login-page-form-login-btn')}
                                            </Button>

                                            {
                                                loginAttempt ? (
                                                    <div className={'login-loader'}>
                                                        <BeatLoader color={'#cd1236'} size={10} />
                                                    </div>
                                                ) : null
                                            }

                                            {
                                                errorSubmit ?
                                                    (
                                                        <Alert className={'error-submit'} style={{ marginTop: 15, whiteSpace: 'pre-line' }} variant={'danger'}>
                                                            {errorSubmit}
                                                        </Alert>
                                                    ) : null
                                            }

                                        </Form.Item>
                                    </Form>
                                )
                        }

                        {
                            meStudentLoginError ?
                                (
                                    <Alert className={'error-submit'} style={{ marginTop: 15, whiteSpace: 'pre-line' }} variant={'danger'}>
                                        {meStudentLoginError}
                                    </Alert>
                                ) : null
                        }
                    </div>

                    <div className={'contact-infos'}>

                        {
                            isInternalNetwork ?
                                (
                                    <>
                                        <div className={'f-infos'}>
                                            <FontAwesomeIcon icon={faPhone} />
                                            <div className={'f-infos-text'}>
                                                <span>{t('footer-phone')} : </span><a href="tel:+1855-646-8228p87952" className={'f-tel'}>1 855-646-8228 #87952</a>
                                            </div>
                                        </div>
                                        <div className={'f-infos'}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                            <div className={'f-infos-text'}>
                                                <span>{t('footer-email')} : </span><a href="mailto:excellence.dev@intact.net">excellence.dev@intact.net</a>
                                            </div>
                                        </div>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <div className={'f-infos'}>
                                            <FontAwesomeIcon icon={faPhone} />
                                            <div className={'f-infos-text'}>
                                                <span>{t('footer-phone')} : </span><a href="tel:+1877-464-2433" className={'f-tel'}>1 877-464-2433</a>
                                            </div>
                                        </div>
                                        <div className={'f-infos'}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                            <div className={'f-infos-text'}>
                                                <span>{t('footer-email')} : </span><a href="mailto:resolution@intact.net">resolution@intact.net</a>
                                            </div>
                                        </div>
                                    </>
                                )
                        }

                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Form.create()(Login);
